import Drilldown from './Drilldown'
import Filters from './Filters'

const Compliance = props =>(
	<div className="pt-2 px-2 px-md-3">
		<Filters/>
		<Drilldown/>
	</div>
)

export default Compliance